import React from 'react';
import './middivider.css';

const MidDivider = () => {
  return (
    <div id="our-story">
      <svg
        className="middivider"
        height="68"
        viewBox="0 0 1623 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1623 51.3595C918.769 92.4472 247.571 47.8691 0 20.4441V0H1623V23.9345V51.3595Z"
          fill="#FFFBFB"
        />
      </svg>
    </div>
  );
};

// const FooterSeparator = () => {
//   return (
//     <div id="our-story">
//       <svg
//         className="footdivider"
//         height="10"
//         viewBox="0 0 1623 68"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M1623 51.3595C918.769 92.4472 247.571 47.8691 0 20.4441V0H1623V23.9345V51.3595Z"
//           fill="#2a2a2a"
//           />

//       </svg>
//     </div>
//   );
// };
const FooterSeparator = () => {
  return (
    <div id="our-story">
      <svg
        width="1632"
        className="footdivider"
        height="42"
        viewBox="0 0 1632 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1632 8.27751C1632 26.9019 1266.66 42 816 42C365.336 42 0 26.9019 0 8.27751C0 -10.3469 365.336 8.27753 816 8.27753C1266.66 8.27753 1632 -10.3469 1632 8.27751Z"
          fill="#292929"
        />
      </svg>
    </div>
  );
};

export { MidDivider, FooterSeparator };

